<template>
    <div>
        <b-modal id="builderNamePop">
                      <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-default">Deck Title</span>
              </div>
              <input name="name" type="text" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default" :value="this.deckName" v-on:keyup.enter="submit">
            </div>
                <button type="button" class="btn btn-primary" v-on:click="submit">Save changes</button>
        </b-modal>




    </div>
</template>

<script>
import axios from 'axios';
import Noty from 'noty';

    export default {
        mounted() {

            if(!this.id){
                $('#builderNamePop').modal({
                    keyboard: false,
                    backdrop: 'static'
                });
            }

        },
        props: ['id','name'],
        data: function(){
            return {
                deckId: this.id,
                deckName: this.name,
            }
        },
        methods: {
            submit: function(e){ 
                var $name = $('#builderNamePop input[name="name"]').val();
                if($name){

                    const url = `/deck/store`;

                    axios.post(url,{id:this.deckId,name:$name}).then(response => {
                    
                        var refresh = false;

                        if(this.deckId == ''){ refresh = true; }
                        this.$emit('setID', response.data.payload.id);
                        this.deckId = response.data.payload.id; 

                        this.$emit('setName', response.data.payload.name);
                        this.deckName = response.data.payload.name;
                        
                        $('#builderNamePop').modal('hide')

                        if(refresh){ window.location = '/deck/edit/'+this.deckId; } // If new deck then refresh

                    }).catch(() => console.warn('Oh. Something went wrong'));

                }else{

                    new Noty({
                        text: 'Please enter a name for your deck',
                        type: 'error',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                    }).show();

                }
            }
        }
    }
</script>